module.exports = __webpack_public_path__ + "img/bottleCodex.faef59a2.png";